<template>
    <div>
        <div class="row">
            <div class="col-12 col-md-6 mt-3">
                <label>Firma</label>
                <input type="text" v-model="company_name" placeholder="Bitte Firma eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Straße / Hausnummer</label>
                <input type="text" v-model="company_address" placeholder="Bitte Straße / Hausnummer eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>PLZ</label>
                <input type="text" v-model.trim="post_code" @blur="clearLocations" @input="getPlz" placeholder="Bitte PLZ eingeben" class="form-control">
                <div style="position: relative">
                    <ul class="list-group" v-if="locations">
                        <li class="list-group-item" v-for="loc in locations" :key="loc.id" @click="selectPlz(loc.zip_code, loc.city)">
                            {{loc.zip_code}} {{loc.city}}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Ort</label>
                <input type="text" v-model="city" placeholder="Bitte Ort eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Telefon</label>
                <input type="text" v-model="company_phone" placeholder="Bitte Telefon eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Fax</label>
                <input type="text" v-model="company_fax" placeholder="Bitte Fax eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>E-Mail-Adresse</label>
                <input type="text" v-model="company_email" @focusout="emailToLowercase($event)" @blur="$v.company_email.$touch()" :class="{ 'is-invalid': $v.company_email.$error }" placeholder="Bitte E-Mail-Adresse eingeben" class="form-control lowercase-field">
                <div class="invalid-feedback" v-if="!$v.company_email.email">Bitte eine gültige E-Mail-Adresse eingeben</div>
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Homepage</label>
                <input type="text" v-model="company_homepage" placeholder="Bitte Homepage eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Geschäftsführer</label>
                <input type="text" v-model="trade_register_representation" placeholder="Bitte Geschäftsführer eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Handelsregister-Nummer</label>
                <input type="text" v-model="trade_register_number" placeholder="Bitte Handelsregister-Nummer eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Umsatzsteueridentifikationsnummer</label>
                <input type="text" v-model="tax_exchange_number" placeholder="Bitte Umsatzsteueridentifikationsnummer eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Steuernummer</label>
                <input type="text" v-model="tax_number" placeholder="Bitte Steuernummer eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Sitz der Gesellschaft</label>
                <input type="text" v-model="trade_register_court" placeholder="Bitte Sitz der Gesellschaft eingeben" class="form-control">
            </div>
        </div>
        <div class="mt-3 text-right">
            <button v-if="create" class="btn btn-success"  @click="weiter()">Speichern</button>
            <button v-if="!create" class="btn btn-success"  @click="save()">Speichern und Schließen</button>
        </div>
    </div>
</template>

<script>
    import { email, numeric } from 'vuelidate/lib/validators';
    import Inserat from '../../../classes/Inserat';

    export default {
        data() {
            return {
                impressum: null,
                company_name: '',
                company_address: '',
                post_code: '',
                city: '',
                company_phone: '',
                company_fax: '',
                company_email: '',
                company_homepage: '',
                trade_register_representation: '',
                trade_register_number: '',
                tax_exchange_number: '',
                tax_number: '',
                trade_register_court: '',
                locations: []
            }
        },
        props:['create'],
        watch: {
            impressum: function(val){
                if(val && Object.keys(val).length > 0){
                    this.company_name = val.company_name;
                    this.company_address = val.company_address;
                    this.post_code = val.post_code;
                    this.city = val.city;
                    this.company_phone = val.company_phone;
                    this.company_fax = val.company_fax;
                    this.company_email = val.company ? val.company_email.toLowerCase() : val.company;
                    this.company_homepage = val.company_homepage;
                    this.trade_register_representation = val.trade_register_representation;
                    this.trade_register_number = val.trade_register_number;
                    this.tax_exchange_number = val.tax_exchange_number;
                    this.tax_number = val.tax_number;
                    this.trade_register_court = val.trade_register_court;
                }
            }
        },
        methods: {
          emailToLowercase(event) {
            if (!event.target.value.match(/([A-Z])+/)) {
              return;
            }

            let email = event.target.value;
            email = event.target.value.toLowerCase();
            this.company_email = email;
          },
            scrollTop() {
                window.scrollTo(0, 0);
            },
            save (){
                this.$v.$touch();
                if(!this.$v.$invalid){
                    let object = this.$store.state.editObject;


                    object.impressum = {
                        company_name: this.company_name,
                        company_address: this.company_address,
                        post_code: this.post_code,
                        city: this.city,
                        company_phone: this.company_phone,
                        company_fax: this.company_fax,
                        company_email: this.company_email ? this.company_email.toLowerCase() : this.company_email,
                        company_homepage: this.company_homepage,
                        trade_register_representation: this.trade_register_representation,
                        trade_register_number: this.trade_register_number,
                        tax_exchange_number: this.tax_exchange_number,
                        tax_number: this.tax_number,
                        trade_register_court: this.trade_register_court,
                    }

                    this.$store.state.loading = true;

                    this.$http.put('/objectApi/updateObject?id='+object.id, object).then(response => {
                        this.$store.state.editObject = object;
                        this.$emit('success', response.data);
                        this.$store.state.loading = false;
                        setTimeout(() => {
                            this.$router.push({name: 'inserat-uebersicht', params: {page: this.$store.state.lastOpenedPage}});
                        }, 1000);
                    }).catch(error => {
                        this.$store.state.loading = false;
                        this.$emit('error', error.response.data.data);
                    });
                }
            },
            weiter(gotoNextTab = true) {
                this.$v.$touch();
                if(!this.$v.$invalid){
                    let inserat = Inserat.getObjectFromJSON(JSON.parse(localStorage.getItem('currentObject')));

                    inserat.setImpressum({
                        company_name: this.company_name,
                        company_address: this.company_address,
                        post_code: this.post_code,
                        city: this.city,
                        company_phone: this.company_phone,
                        company_fax: this.company_fax,
                        company_email: this.company_email ? this.company_email.toLowerCase() : this.company_email,
                        company_homepage: this.company_homepage,
                        trade_register_representation: this.trade_register_representation,
                        trade_register_number: this.trade_register_number,
                        tax_exchange_number: this.tax_exchange_number,
                        tax_number: this.tax_number,
                        trade_register_court: this.trade_register_court,
                    });

                    localStorage.setItem('currentObject', JSON.stringify(inserat));
                    if(gotoNextTab) {
                        this.$emit('saveObject');
                    }
                }
            },
            getPlz() {
                this.$http.get('/objectApi/getPlz?term='+this.post_code).then((response) => {
                    this.locations = JSON.parse(response.data);
                });
            },
            selectPlz(plz, city) {
                this.post_code = plz;
                this.city = city;
                this.locations = [];
            },
            clearLocations() {
                setTimeout(() => { this.locations = [] }, 500);
            },
        },
        mounted() {
          this.scrollTop();
          if(this.create){
              let jsonObject = JSON.parse(localStorage.getItem('currentObject'));
              let inserat = Inserat.getObjectFromJSON(jsonObject);
              let impressum = inserat.getImpressum();

              if(impressum && Object.keys(impressum).length > 0) {
                 this.impressum = impressum;
              }
              else
              {
                this.$store.dispatch('IMPRESSUM');
                this.$store.watch( () => {
                    return this.$store.getters.impressum; // could also put a Getter here
                    }, (impressum) =>{
                        this.impressum = impressum;
                    }
                );
              }
          }
          else{
              this.$store.dispatch('IMPRESSUM');
              this.$store.watch( () => {
                  return this.$store.getters.impressum; // could also put a Getter here
                  }, (impressum) =>{
                      this.impressum = impressum;
                  }
              );
          }

        },
        validations: {
            company_email: {email},
            post_code: {numeric}
        },
        beforeDestroy() {
          if(this.create){
            this.weiter(false);
          }
        }
    }
</script>

<style scoped>
.list-group{
    max-height: 400px;
    position: absolute;
    top: 0;
    left: 0;
    overflow: auto;
    width: 300px;
    z-index: 10;
}
.list-group-item{
    cursor: pointer;
}
.lowercase-field {
  text-transform: lowercase;
}
</style>
